import { Fragment, ReactNode, useEffect } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { useLanguage } from "../context/LanguageContext";
import { LAST_UPDATED, LEGAL_PATHS, LegalDocKey, legalContent } from "../legal/legalContent";

const LINK_PATTERN = /\[([^\]]+)\]\(([^)]+)\)/;

// Metindeki [etiket](/yol) kalıplarını router linkine çevirir.
// split, yakalama gruplarıyla [metin, etiket, yol, metin, ...] dizisi döndürür.
function renderText(text: string): ReactNode {
  const parts = text.split(new RegExp(LINK_PATTERN, "g"));
  const nodes: ReactNode[] = [];
  for (let i = 0; i < parts.length; i += 3) {
    if (parts[i]) nodes.push(<Fragment key={i}>{parts[i]}</Fragment>);
    if (i + 2 < parts.length) {
      nodes.push(
        <Link key={i + 1} to={parts[i + 2]} style={{ color: "#c20e1a" }}>
          {parts[i + 1]}
        </Link>
      );
    }
  }
  return nodes;
}

function LegalPage({ doc }: { doc: LegalDocKey }) {
  const { t, lang } = useLanguage();
  const content = legalContent[lang][doc];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [doc]);

  const otherDocs = (Object.keys(LEGAL_PATHS) as LegalDocKey[]).filter((k) => k !== doc);

  return (
    <div className="container py-4" style={{ maxWidth: "820px" }}>
      <Helmet>
        <title>{`${content.title} | Mutfacık`}</title>
      </Helmet>

      <h1 className="fw-bold mb-1" style={{ fontSize: "1.75rem" }}>{content.title}</h1>
      <p className="text-muted small mb-4">
        {t("legal.lastUpdated")}: {LAST_UPDATED[lang]}
      </p>

      {content.intro.map((p, i) => (
        <p key={i} style={{ lineHeight: 1.7 }}>{renderText(p)}</p>
      ))}

      {content.sections.map((section) => (
        <section key={section.heading} className="mt-4">
          <h2 className="fw-semibold mb-2" style={{ fontSize: "1.15rem", color: "#c20e1a" }}>
            {section.heading}
          </h2>
          {section.paragraphs?.map((p, i) => (
            <p key={i} style={{ lineHeight: 1.7 }}>{renderText(p)}</p>
          ))}
          {section.items && (
            <ul style={{ lineHeight: 1.7 }}>
              {section.items.map((item, i) => (
                <li key={i} className="mb-1">{renderText(item)}</li>
              ))}
            </ul>
          )}
        </section>
      ))}

      <div className="d-flex flex-wrap gap-2 mt-5 pt-3 border-top">
        {otherDocs.map((k) => (
          <Link key={k} to={LEGAL_PATHS[k]} className="btn btn-outline-secondary btn-sm rounded-pill">
            {t(`legal.${k}`)}
          </Link>
        ))}
      </div>
    </div>
  );
}

export default LegalPage;
